import React, { Component } from 'react'
import { Router, Route } from 'react-router-dom'
import Layout from './container/LayoutContainer'
import AdminBoard from './components/Admin/AdminBoard'
import Map from './container/MapContainer'
import Timeline from './container/TimelineContainer'
import Legend from './container/LegendContainer'
import TopicLayer from './container/TopicLayerContainer'
import Intro from './container/IntroContainer'
import history from './History'
import Auth from './Auth'
import styles from './App.css'

const auth = new Auth()

const handleAuthentication = nextState => {
  if (/access_token|id_token|error/.test(nextState.location.hash)) {
    auth.handleAuthentication()
  }
}

class App extends Component {
  render() {
    return (
      <div className={styles.App}>
        <Layout
          timeline={<Timeline width={3540} />}
          map={<Map />}
          legend={<Legend />}
          topic={<TopicLayer />}
          intro={<Intro />}
        />
      </div>
    )
  }
}

const Routed = () => (
  <Router history={history} component={App}>
    <div>
      <Route exact path="/" component={App} />
      <Route path="/admin" render={() => <AdminBoard auth={auth} />} />
      <Route
        path="/callback"
        render={props => {
          handleAuthentication(props)
          return null
        }}
      />
    </div>
  </Router>
)

export default Routed
